// Form1.js
import React, { useState, useRef } from 'react';
import ChatBox from '../../custom_elements/ChatBox';
import {CustomInput, validationRules} from '../../custom_elements/CustomInput';
import CustomSelect from '../../custom_elements/CustomSelect';
import CustomCheckbox from '../../custom_elements/CustomCheckbox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSquareMinus } from '@fortawesome/free-solid-svg-icons';

export default function Form3({ nextForm, passGetFormData, passValidateAllFormFields, retrievedFormData = {}, sendChat }) {
    const formRefs = useRef([]);  // Reference array to store refs of CustomInput fields

    const [vorbelastungCount, setVorbelastungCount] = useState([1]);
    const [selectValues, setSelectValues] = useState({});

    // Diese Funktion wird in der Parent-Komponente aufgerufen, um die Formulardaten zu erhalten
    // und dann an die API zu senden. Hier liegt vermutlich der Fehler, dass bei Setzen von getFormData
    // das Formular nur aus den Elementen für Vorlast 1 besteht, werden neue Vorlasten hinzugefügt,
    // müsste diese Funktion neu an die parent Komponente übergeben werden
    const getFormData = () => {
        console.log("INSIDE GETFORMDATA on Form3");
        const form = document.getElementById('form3');
        const formData = new FormData(form);
        const data = {};
        for (let [key, value] of formData.entries()) {
            data[key] = value;
        }
        return data;
    };

    React.useEffect(() => {
        const initialValues = {};
        Object.keys(retrievedFormData || {}).forEach((key) => {
            const match = key.match(/^vor(\d+)_zweck$/);
            if (match) {
                const index = match[1];
                initialValues[index] = parseInt(retrievedFormData[key], 10);
            }
        });
        setSelectValues(initialValues);
    }, [retrievedFormData]);

    React.useEffect(() => {
        console.log('Form3 mounted');
        if (retrievedFormData) {
            if (('vor2_zweck' in retrievedFormData) && retrievedFormData['vor2_zweck']) {
                setVorbelastungCount([1, 2]);
            }
            if (('vor3_zweck' in retrievedFormData) && retrievedFormData['vor3_zweck']) {
                setVorbelastungCount([1, 2, 3]);
            }
        }
        passGetFormData(() => getFormData); // Pass the getFormData function to the parent
    }, [passGetFormData]);


    const validateAllFormFields = () => {
      console.log("validateAllFormFields in Form3");
      let isValid = true;
console.log(formRefs);
      // Ensure refs are properly populated
      if (formRefs.current.length === 0) {
        console.error("No form refs found!");
        return false;
      }

      // Loop through all form inputs and call validateField on each one
      formRefs.current.forEach(inputRef => {
        if(inputRef != null) {
          console.log("checking ref: ", inputRef);
          // Check if inputRef is defined and properly set
          if (inputRef?.validateField()) {
            console.log("Field is valid:", inputRef?.validateField());
          } else {
            console.warn("Ref is not initialized or validateField failed:", inputRef);
            isValid = false; // Optional: Fail validation if ref is not set or invalid
          }
        }
      });

      return isValid;
    };

    React.useEffect(() => {
        console.log("INSIDE useEffect passValidateAllFormFields on Form3");

        passValidateAllFormFields(() => validateAllFormFields);
    }, [passValidateAllFormFields]);



    const addVorlast = () => {
        setVorbelastungCount((prevState) => {
            const newArray = [...prevState, prevState.length + 1];
            console.log("Before setting state:", newArray);
            return newArray;
        });
        passGetFormData(() => getFormData); // Pass the getFormData function to the parent
    };

    const removeVorlast = () => {
        setVorbelastungCount((prevState) => {
            // Remove the last element
            const newArray = prevState.slice(0, -1); // Create a new array without the last element
            console.log("Before setting state:", newArray);
            return newArray;
        });
        passGetFormData(() => getFormData); // Pass the getFormData function to the parent
    };

    const handleSelectChange = (vorlast, event) => {
      const value = event.target.value;
      setSelectValues(prev => ({ ...prev, [vorlast]: parseInt(value, 10) }));
    };

    return (
        <div className="formFieldBox">
            <a className="toggleButton" style={{cursor: "default"}}>
                VORBELASTUNGEN
            </a>
            <form id={"form3"}>
            {vorbelastungCount.map(vorlast => (
                <>
                <div className="formFieldContent">
                {vorlast > 1 && <span onClick={removeVorlast} className="remove-pers" style={{padding: "10px"}}><FontAwesomeIcon
                            size="xl"
                            icon={faSquareMinus}
                        /></span>}
                    <div className="fieldDiv">
                        <CustomSelect
                          ref={el => formRefs.current[`vor${vorlast}_zweck`] = el}
                          formData={retrievedFormData}
                          label="Vorbelastung für*"
                          name={`vor${vorlast}_zweck`}
                          rules={[{ ruleKey: "required" }]}
                          onChange={event => handleSelectChange(vorlast, event)}
                        >
                          <option value="0">Keine</option>
                          <option value="1">Leasing</option>
                          <option value="2">Privatkredit</option>
                          <option value="3">Hypothekarkredit</option>
                          <option value="4">Hypothekarkredit auf finanzierender Liegenschaft</option>
                          <option value="5">Versandhaus</option>
                          <option value="6">Liegenschaftskauf</option>
                          <option value="7">Interne Kontorahmen</option>
                          <option value="8">Kreditkarten</option>
                          <option value="9">Firmenkredit</option>
                          <option value="10">Sonstiges</option>
                        </CustomSelect>
                    </div>

                    <div className="fieldDiv">
                        <CustomInput
                          ref={el => formRefs.current[vorlast+'2'] = el}
                          sendChat={sendChat}
                          formData={retrievedFormData}
                          label="Aktuelle Aushaftung"
                          name={"vor"+vorlast+"_saldo"}
                          rules={[
                            { ruleKey: "number" },
                            ...(selectValues[vorlast] > 0 ? [{ ruleKey: "required" }] : [])
                          ]}
                        />

                        <CustomInput
                          ref={el => formRefs.current[vorlast+'3'] = el}
                          sendChat={sendChat}
                          formData={retrievedFormData}
                          label="urspr. Laufzeit"
                          name={"vor"+vorlast+"_ur_lz"}
                          rules={[
                            { ruleKey: "number" },
                            ...(selectValues[vorlast] > 0 ? [{ ruleKey: "required" }] : [])
                          ]}
                        />
                    </div>

                    <div className="fieldDiv">
                        <CustomInput
                          ref={el => formRefs.current[vorlast+'4'] = el}
                          sendChat={sendChat}
                          formData={retrievedFormData}
                          label="Restlaufzeit (Monate)"
                          name={"vor"+vorlast+"_monate"}
                          rules={[
                            { ruleKey: "number" },
                            ...(selectValues[vorlast] > 0 ? [{ ruleKey: "required" }] : [])
                          ]}
                        />

                        <CustomInput
                          ref={el => formRefs.current[vorlast+'5'] = el}
                          sendChat={sendChat}
                          formData={retrievedFormData}
                          label="urspr. Kreditbetrag"
                          name={"vor"+vorlast+"_ur_betrag"}
                          rules={[
                            { ruleKey: "number" },
                            ...(selectValues[vorlast] > 0 ? [{ ruleKey: "required" }] : [])
                          ]}
                        />
                    </div>

                    <div className="fieldDiv">
                        <CustomInput
                          ref={el => formRefs.current[vorlast+'6'] = el}
                          sendChat={sendChat}
                          formData={retrievedFormData}
                          label="Monat. Rate"
                          name={"vor"+vorlast+"_rate"}
                          rules={[
                            { ruleKey: "number" },
                            ...(selectValues[vorlast] > 0 ? [{ ruleKey: "required" }] : [])
                          ]}
                        />

                        <CustomCheckbox sendChat={sendChat} formData={retrievedFormData} label="Umschuldung erwünscht" name={"vor"+vorlast+"_um"} rules={[{ruleKey: "number"}]} />
                    </div>
                </div>
                {vorlast != vorbelastungCount.length && (
                <hr style={{width: "80%", margin: "auto", marginBottom: "30px"}}/>
                )}
                </>
            ))}

            {vorbelastungCount.length < 3 && (
                <div className="add_form_button">
                    <span id="add_vorlast" onClick={addVorlast}>Vorbelastung hinzufügen &nbsp;
                        <FontAwesomeIcon
                            size=""
                            icon={faPlus}
                        />
                    </span>
                </div>
                )}
            </form>
        </div>
    );
}
